
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1347"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1347",
    "ar-eg": "static-7.1347",
    "bg": "static-7.1347",
    "bn": "static-7.1347",
    "ca-es": "static-7.1347",
    "cs": "static-7.1347",
    "da": "static-7.1347",
    "de": "static-7.1347",
    "el": "static-7.1347",
    "en-gb": "static-7.1347",
    "en": "static-7.1347",
    "es-mx": "static-7.1347",
    "es": "static-7.1347",
    "et": "static-7.1347",
    "fi": "static-7.1347",
    "fr-ca": "static-7.1347",
    "fr": "static-7.1347",
    "he-il": "static-7.1347",
    "hi": "static-7.1347",
    "hr": "static-7.1347",
    "hu": "static-7.1347",
    "id": "static-7.1347",
    "it": "static-7.1347",
    "ja": "static-7.1347",
    "ko": "static-7.1347",
    "lt": "static-7.1347",
    "ms": "static-7.1347",
    "nl": "static-7.1347",
    "no": "static-7.1347",
    "pl": "static-7.1347",
    "pt-br": "static-7.1347",
    "pt-pt": "static-7.1347",
    "ro": "static-7.1347",
    "ru": "static-7.1347",
    "sk": "static-7.1347",
    "sl": "static-7.1347",
    "sv": "static-7.1347",
    "th": "static-7.1347",
    "tl": "static-7.1347",
    "tr": "static-7.1347",
    "uk": "static-7.1347",
    "vi": "static-7.1347",
    "x-pseudo": "static-7.1347",
    "zh-cn": "static-7.1347",
    "zh-hk": "static-7.1347",
    "zh-tw": "static-7.1347"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1347'}); }
})();


